// tslint:disable:no-empty-interface
// tslint:disable:max-line-length
// tslint:disable: no-use-before-declare

import {strEnum} from "../../types";
import {ITCIApplication, TCITenantAppType} from "./tci-application";
import {ITCIFileMap} from "./tci-util";
import * as lodash from "lodash";


/*************************************************************************************************/
/*                        TCI Tenant Service Provider                                            */
/*************************************************************************************************/
/**
 * TCI SERVICE_PROVIDER_TYPES
 * @type {{[K in string]: K}}
 */
export const TCI_TENANT_SERVICE_PROVIDER_TYPE = strEnum([
    "APP_ENV",
    "APP_CUSTOMIZE",
    "APP_CREATE",
    "APP_UPDATE",
    "APP_DELETE",
    "APP_EXTENSION",
    "APP_DEPLOY",
    "CONNECTION_SERVICE",
    "MARKETPLACE",
    "APP_MONITORING",
    "SUPPLEMENTS",
    "EXEC_HISTORY"
]);
export type TCI_TENANT_SERVICE_PROVIDER_TYPE = keyof typeof TCI_TENANT_SERVICE_PROVIDER_TYPE;

/**
 * interface @ITCITenantServiceProvider
 */
export interface ITCITenantServiceProvider {

    getServiceProviderType(): TCI_TENANT_SERVICE_PROVIDER_TYPE;

}

/**
 * Abstract class @TCITenantServiceProvider
 */
export abstract class TCITenantServiceProvider implements ITCITenantServiceProvider {

    constructor(protected providerType: TCI_TENANT_SERVICE_PROVIDER_TYPE) {
    }

    getServiceProviderType(): TCI_TENANT_SERVICE_PROVIDER_TYPE {
        return this.providerType;
    }
}

/**
 * TCI Component Selectors
 */
export class TCITenantSelectorType {
    public static TCI_CREATE_APP = new TCITenantSelectorType("tci-create-app");
    public static TCI_APP_CREATE_FILE_UPLOAD = new TCITenantSelectorType("tci-app-create-file-upload");
    public static TCI_APP_CREATE_API_SPEC = new TCITenantSelectorType("tci-app-create-api-spec");
    public static TCI_APP_CREATE_GRAPHQL_SCHEMA = new TCITenantSelectorType("tci-app-create-graphql-schema");
    public static TCI_APP_CREATE_API_SELECT = new TCITenantSelectorType("tci-app-create-api-select");
    public static TCI_APP_CREATE_MARKETPLACE = new TCITenantSelectorType("tci-app-create-marketplace");
    public static TCI_APP_LIST_MINI_DETAIL = new TCITenantSelectorType("tci-app-list-mini-detail");
    public static TCI_APP_DETAIL_FLOWS = new TCITenantSelectorType("tci-app-detail-flows");
    public static TCI_APP_DETAIL_PROCESSES = new TCITenantSelectorType("tci-app-detail-processes");
    public static TCI_APP_DETAIL_ENDPOINTS = new TCITenantSelectorType("tci-app-detail-endpoints");
    public static TCI_APP_DETAIL_MARK_LIVE = new TCITenantSelectorType("tci-app-detail-mark-live");
    public static TCI_APP_DETAIL_SET_ENDPOINT = new TCITenantSelectorType("tci-app-detail-set-endpoint");
    public static TCI_APP_DETAIL_CONNECTIONS = new TCITenantSelectorType("tci-app-detail-connections");
    public static TCI_APP_DETAIL_MONITORING = new TCITenantSelectorType("tci-app-detail-metrics");
    public static TCI_APP_DETAIL_ENVIRONMENT = new TCITenantSelectorType("tci-app-detail-environment");
    public static TCI_APP_DETAIL_LOGS = new TCITenantSelectorType("tci-app-detail-logs");
    public static TCI_APP_DETAIL_ELASTIC_LOGS = new TCITenantSelectorType("tci-app-detail-elastic-logs");
    public static TCI_APP_DETAIL_LOGS_DOWNLOAD = new TCITenantSelectorType("tci-app-detail-logs-download");
    public static TCI_APP_DETAIL_HISTORY = new TCITenantSelectorType("tci-app-detail-history");
    public static TCI_APP_DETAIL_ALERT = new TCITenantSelectorType("tci-app-detail-alert");
    public static TCI_APP_DETAIL_SCHEDULE = new TCITenantSelectorType("tci-app-detail-schedule");
    public static TCI_APP_DETAIL_EXEC_HISTORY = new TCITenantSelectorType("tci-app-detail-exec-history");
    public static TCI_APP_DETAIL_TRANSFER_OWNERSHIP = new TCITenantSelectorType("tci-app-detail-transfer-owner");
    public static TCI_APP_DETAIL_COPY_APPLICATION = new TCITenantSelectorType("tci-app-detail-copy-app");
    public static TCI_APP_DETAIL_EDIT = new TCITenantSelectorType("tci-app-detail-edit");
    public static TCI_APP_DETAIL_RENAME_APPLICATION = new TCITenantSelectorType("tci-app-detail-rename-app");
    public static TCI_APP_DETAIL_REPLACE_APPLICATION = new TCITenantSelectorType("tci-app-detail-replace-app");
    public static TCI_APP_DETAIL_SCRIBE_REQUEST_LOGS = new TCITenantSelectorType("tci-app-list-scribe-request-logs");
    public static TCI_APP_DETAIL_PANEL_LIVE_STATS = new TCITenantSelectorType("tci-app-detail-live-stats");
    public static TCI_APP_DETAIL_UPLOAD_EXISTING_APP = new TCITenantSelectorType("tci-app-detail-upload-existing-app");
    public static TCI_APP_DETAIL_ENV_APP_VARS = new TCITenantSelectorType("tci-app-detail-env-app-vars");
    public static TCI_APP_DETAIL_ENV_ENG_VARS = new TCITenantSelectorType("tci-app-detail-env-eng-vars");
    public static TCI_APP_DETAIL_ENV_APP_VPN = new TCITenantSelectorType("tci-app-detail-env-app-vpn");
    public static TCI_APP_DETAIL_ENV_HYBRID_CONN = new TCITenantSelectorType("tci-app-detail-env-hybrid-conn");
    public static TCI_APP_DETAIL_USER_TIMESTAMP = new TCITenantSelectorType("tci-app-detail-user-timestamp");
    public static TCI_APP_DETAIL_ENV_AUTO_SCALE = new TCITenantSelectorType("tci-app-detail-env-auto-scale");
    public static TCI_APP_DETAIL_APP_VERSION = new TCITenantSelectorType("tci-app-detail-app-version");
    public static TCI_APP_DETAIL_APP_READ_ONLY = new TCITenantSelectorType("tci-app-detail-app-read-only");
    public static TCI_APP_DETAIL_CREATE_LISTING = new TCITenantSelectorType("tci-app-detail-create-listing");
    public static TCI_APP_DETAIL_DESIGNER = new TCITenantSelectorType("tci-app-detail-designer");
    public static TCI_APP_DETAIL_SHARE_EXTERNALLY = new TCITenantSelectorType("tci-app-detail-share-externally");
    public static TCI_APP_DETAIL_EX_HST_LISTING = new TCITenantSelectorType("tci-app-detail-ex-hst-listing");
    // public static TCI_APP_DETAIL_UPGRADE_LISTING = new TCITenantSelectorType("tci-app-detail-upgrade-listing");
    public static TCI_ENV_TOOLS_MANAGED_CONNECTORS = new TCITenantSelectorType("tci-env-tools-managed-connectors");
    public static TCI_ENV_TOOLS_SUPPLEMENTS = new TCITenantSelectorType("tci-env-tools-supplements");
    public static TCI_ENV_TOOLS_SUPPLEMENTS_EDIT = new TCITenantSelectorType("tci-env-tools-supplements-edit");
    public static TCI_ENV_TOOLS_SUPPLEMENTS_DOWNLOAD = new TCITenantSelectorType("tci-env-tools-supplements-download");
    public static TCI_ENV_TOOLS_EXTENSIONS = new TCITenantSelectorType("tci-env-tools-extensions");
    public static TCI_ENV_TOOLS_AGENTS = new TCITenantSelectorType("tci-env-tools-agents");
    public static TCI_ENV_TOOLS_AGENTS_LIST = new TCITenantSelectorType("tci-env-tools-agents-list");
    public static TCI_ENV_TOOLS_HYBRID_CONNECTION = new TCITenantSelectorType("tci-env-tools-hybrid-connection");
    public static TCI_ENV_TOOLS_LOOKUP_TABLES = new TCITenantSelectorType("tci-env-tools-lookup-tables");
    public static TCI_ENV_TOOLS_SECURITY_SETTINGS = new TCITenantSelectorType("tci-env-tools-security-settings");
    public static TCI_ENV_TOOLS_NOTIFICATIONS = new TCITenantSelectorType("tci-env-tools-notifications");
    public static TCI_ENV_TOOLS_DLD_TIBCLI = new TCITenantSelectorType("tci-env-tools-dld-tibcli");
    public static TCI_ENV_TOOLS_DLD_BW = new TCITenantSelectorType("tci-env-tools-dld-bw");
    public static TCI_ENV_TOOLS_DLD_DRIVERS = new TCITenantSelectorType("tci-env-tools-dld-drivers");
    public static TCI_ENV_TOOLS_DLD_AGENTS = new TCITenantSelectorType("tci-env-tools-dld-agents");
    public static TCI_ENV_TOOLS_AGENT_CONNECT_CLOUD = new TCITenantSelectorType("tci-env-tools-agent-conn-cloud");
    public static TCI_ENV_TOOLS_AGENT_CONNECT_ON_PREM = new TCITenantSelectorType("tci-env-tools-agent-conn-on-prem");
    public static TCI_ENV_TOOLS_AGENT_HYBRID = new TCITenantSelectorType("tci-env-tools-agent-hybrid");
    public static TCI_ENV_TOOLS_AGENT_UNIFIED_MGMT = new TCITenantSelectorType("tci-env-tools-agent-unified-mgmt");
    public static TCI_ENV_TOOLS_AUTOMATE_ADMINISTRATION = new TCITenantSelectorType("tci-env-tools-automate-administration");
    public static TCI_SECURITY_SCRIBE = new TCITenantSelectorType("tci-security-scribe");
    public static TCI_ENV_TOOLS_VPN_CONNECTIONS = new TCITenantSelectorType("tci-env-tools-vpn-connections");
    public static TCI_ENV_TOOLS_ALERT = new TCITenantSelectorType("tci-env-tools-alert");
    public static TCI_MARKETPLACE_CONNECTOR_DETAIL = new TCITenantSelectorType("tci-marketplace-connector-detail");
    public static TCI_APP_LIST_MONITORING_APP_PEEK = new TCITenantSelectorType("tci-app-list-monitoring-app-peek");
    public static TCI_APP_LIST_MONITORING_APP_PEEK_EXEC = new TCITenantSelectorType("tci-app-list-monitoring-app-peek-exec");
    public static TCI_MENU_APP_MONITORING_METRICS_COLLECTION = new TCITenantSelectorType("tci-app-monitoring-metrics-collection");
    public static TCI_MENU_APP_MONITORING_FLOWS = new TCITenantSelectorType("tci-app-monitoring-flows");
    public static TCI_MENU_APP_MONITORING_PROCESSES = new TCITenantSelectorType("tci-app-monitoring-processes");
    public static TCI_MENU_APP_MONITORING_TRIGGERS = new TCITenantSelectorType("tci-app-monitoring-triggers");
    public static TCI_MENU_APP_MONITORING_RESOURCE_METRICS = new TCITenantSelectorType("tci-app-monitoring-resource-metrics");
    public static TCI_CONN_LIST_CONN_DELETE = new TCITenantSelectorType("tci-conn-list-conn-delete");
    public static TCI_CONN_MENU_RESET_METADATA = new TCITenantSelectorType("tci-conn-menu-reset-metadata");
    public static TCI_CONN_MENU_CHANGE_VISIBILITY = new TCITenantSelectorType("tci-conn-menu-change-visibility");
    public static TCI_MKP_EDIT_DETAILS = new TCITenantSelectorType("tci-mkp-edit-details");
    public static TCI_MENU_MKP_MANAGE_ACCESS = new TCITenantSelectorType("tci-mkp-manage-access");
    public static TCI_MENU_MKP_CHANGE_VISIBILITY_PUBLIC = new TCITenantSelectorType("tci-mkp-change-visibility-public");
    public static TCI_MENU_MKP_CHANGE_VISIBILITY_PRIVATE = new TCITenantSelectorType("tci-mkp-change-visibility-private");
    public static TCI_MENU_MKP_WITHDRAW_PENDING_LISTING = new TCITenantSelectorType("tci-mkp-withdraw-pending-listing");
    public static TCI_MENU_MKP_DELETE_LISTING = new TCITenantSelectorType("tci-mkp-delete-listing");


    public static getAllSelectors(): TCITenantSelectorType[] {
        return [
            TCITenantSelectorType.TCI_CREATE_APP,
            TCITenantSelectorType.TCI_APP_CREATE_FILE_UPLOAD,
            TCITenantSelectorType.TCI_APP_CREATE_API_SELECT,
            TCITenantSelectorType.TCI_APP_CREATE_GRAPHQL_SCHEMA,
            TCITenantSelectorType.TCI_APP_CREATE_MARKETPLACE,
            TCITenantSelectorType.TCI_APP_LIST_MINI_DETAIL,
            TCITenantSelectorType.TCI_APP_DETAIL_FLOWS,
            TCITenantSelectorType.TCI_APP_DETAIL_PROCESSES,
            TCITenantSelectorType.TCI_APP_DETAIL_ENDPOINTS,
            TCITenantSelectorType.TCI_APP_DETAIL_MARK_LIVE,
            TCITenantSelectorType.TCI_APP_DETAIL_SET_ENDPOINT,
            TCITenantSelectorType.TCI_APP_DETAIL_CONNECTIONS,
            TCITenantSelectorType.TCI_APP_DETAIL_MONITORING,
            TCITenantSelectorType.TCI_APP_DETAIL_ENVIRONMENT,
            TCITenantSelectorType.TCI_APP_DETAIL_LOGS,
            TCITenantSelectorType.TCI_APP_DETAIL_ELASTIC_LOGS,
            TCITenantSelectorType.TCI_APP_DETAIL_HISTORY,
            TCITenantSelectorType.TCI_APP_DETAIL_ALERT,
            TCITenantSelectorType.TCI_APP_DETAIL_SCHEDULE,
            TCITenantSelectorType.TCI_APP_DETAIL_EXEC_HISTORY,
            TCITenantSelectorType.TCI_APP_DETAIL_TRANSFER_OWNERSHIP,
            TCITenantSelectorType.TCI_APP_DETAIL_COPY_APPLICATION,
            TCITenantSelectorType.TCI_APP_DETAIL_EDIT,
            TCITenantSelectorType.TCI_APP_DETAIL_RENAME_APPLICATION,
            TCITenantSelectorType.TCI_APP_DETAIL_REPLACE_APPLICATION,
            TCITenantSelectorType.TCI_APP_DETAIL_SCRIBE_REQUEST_LOGS,
            TCITenantSelectorType.TCI_APP_DETAIL_PANEL_LIVE_STATS,
            TCITenantSelectorType.TCI_APP_DETAIL_UPLOAD_EXISTING_APP,
            TCITenantSelectorType.TCI_APP_DETAIL_APP_VERSION,
            TCITenantSelectorType.TCI_APP_DETAIL_APP_READ_ONLY,
            TCITenantSelectorType.TCI_APP_DETAIL_CREATE_LISTING,
            TCITenantSelectorType.TCI_APP_DETAIL_DESIGNER,
            TCITenantSelectorType.TCI_APP_DETAIL_SHARE_EXTERNALLY,
            // TCITenantSelectorType.TCI_APP_DETAIL_UPGRADE_LISTING,
            TCITenantSelectorType.TCI_ENV_TOOLS_MANAGED_CONNECTORS,
            TCITenantSelectorType.TCI_ENV_TOOLS_SUPPLEMENTS,
            TCITenantSelectorType.TCI_ENV_TOOLS_SUPPLEMENTS_EDIT,
            TCITenantSelectorType.TCI_ENV_TOOLS_SUPPLEMENTS_DOWNLOAD,
            TCITenantSelectorType.TCI_ENV_TOOLS_EXTENSIONS,
            TCITenantSelectorType.TCI_ENV_TOOLS_AGENTS,
            TCITenantSelectorType.TCI_ENV_TOOLS_AGENTS_LIST,
            TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_CONNECT_CLOUD,
            TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_CONNECT_ON_PREM,
            TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_HYBRID,
            TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_UNIFIED_MGMT,
            TCITenantSelectorType.TCI_ENV_TOOLS_HYBRID_CONNECTION,
            TCITenantSelectorType.TCI_ENV_TOOLS_LOOKUP_TABLES,
            TCITenantSelectorType.TCI_ENV_TOOLS_SECURITY_SETTINGS,
            TCITenantSelectorType.TCI_ENV_TOOLS_NOTIFICATIONS,
            TCITenantSelectorType.TCI_ENV_TOOLS_DLD_BW,
            TCITenantSelectorType.TCI_ENV_TOOLS_DLD_TIBCLI,
            TCITenantSelectorType.TCI_ENV_TOOLS_DLD_DRIVERS,
            TCITenantSelectorType.TCI_ENV_TOOLS_DLD_AGENTS,
            TCITenantSelectorType.TCI_SECURITY_SCRIBE,
            TCITenantSelectorType.TCI_ENV_TOOLS_VPN_CONNECTIONS,
            TCITenantSelectorType.TCI_ENV_TOOLS_ALERT,
            TCITenantSelectorType.TCI_ENV_TOOLS_AUTOMATE_ADMINISTRATION,
            // TCITenantSelectorType.TCI_MARKETPLACE_CONNECTOR_DETAIL,
            TCITenantSelectorType.TCI_APP_DETAIL_ENV_APP_VARS,
            TCITenantSelectorType.TCI_APP_DETAIL_ENV_ENG_VARS,
            TCITenantSelectorType.TCI_APP_DETAIL_ENV_APP_VPN,
            TCITenantSelectorType.TCI_APP_DETAIL_ENV_HYBRID_CONN,
            TCITenantSelectorType.TCI_MENU_APP_MONITORING_METRICS_COLLECTION,
            TCITenantSelectorType.TCI_MENU_APP_MONITORING_FLOWS,
            TCITenantSelectorType.TCI_MENU_APP_MONITORING_PROCESSES,
            TCITenantSelectorType.TCI_MENU_APP_MONITORING_TRIGGERS,
            TCITenantSelectorType.TCI_MENU_APP_MONITORING_RESOURCE_METRICS,
            TCITenantSelectorType.TCI_APP_LIST_MONITORING_APP_PEEK,
            TCITenantSelectorType.TCI_APP_LIST_MONITORING_APP_PEEK_EXEC,
            TCITenantSelectorType.TCI_APP_DETAIL_ENV_AUTO_SCALE,
            TCITenantSelectorType.TCI_APP_DETAIL_USER_TIMESTAMP,
            TCITenantSelectorType.TCI_CONN_LIST_CONN_DELETE,
            TCITenantSelectorType.TCI_CONN_MENU_RESET_METADATA,
            TCITenantSelectorType.TCI_CONN_MENU_CHANGE_VISIBILITY,
            TCITenantSelectorType.TCI_MKP_EDIT_DETAILS,
            TCITenantSelectorType.TCI_MENU_MKP_MANAGE_ACCESS,
            TCITenantSelectorType.TCI_MENU_MKP_CHANGE_VISIBILITY_PUBLIC,
            TCITenantSelectorType.TCI_MENU_MKP_CHANGE_VISIBILITY_PRIVATE,
            TCITenantSelectorType.TCI_MENU_MKP_WITHDRAW_PENDING_LISTING,
            TCITenantSelectorType.TCI_MENU_MKP_DELETE_LISTING,
            TCITenantSelectorType.TCI_APP_DETAIL_EX_HST_LISTING,
        ];
    }

    public static createPseudoSelector(val: string) {
        return new TCITenantSelectorType(val);
    }

    private constructor(private val: string) {
    }

    public isEqualTo(v: string): boolean {
        return this.val === v;
    }

    public is(v1: any, v2: any): boolean {
        return lodash.isEqual(v1, v2);
    }

    public toString(): string {
        return this.val;
    }
}

/***************************************************************************************************/
/*                                      Tenant Component Options                                   */

/***************************************************************************************************/
export interface ITCIMenuInput {
    [key: string]: any;
}

export interface ITCIOptionType<T> {
    [key: string]: T;
}

export interface ITCITenantModalType {
    getHeight(): number;

    getWidth(): number;
}

export class TCITenantModalType implements ITCITenantModalType {
    // http://ux.tibco.com/uxpl/components/modals.html
    public static TCI_MODAL_INLINE = new TCITenantModalType(0, 0);
    public static TCI_MODAL_SMALL = new TCITenantModalType(512, 276);
    public static TCI_MODAL_MEDIUM = new TCITenantModalType(720, 753);
    public static TCI_MODAL_CREATE_DIALOG = new TCITenantModalType(1184, 704);
    public static TCI_MODAL_LARGE = new TCITenantModalType(1392, 728);
    public static TCI_MODAL_MARKETPLACE_MANAGE_ACCESS = new TCITenantModalType(820, 650);
    public static TCI_MODAL_MARKETPLACE = new TCITenantModalType(820, 650);

    private constructor(private width: number, private height: number) {
    }

    getHeight(): number {
        return this.height;
    }

    getWidth(): number {
        return this.width;
    }
}

/**
 * TCI Modal Popup options
 */
export interface ITCITenantModalOptions {
    getModalType(): ITCITenantModalType;
}

/**
 * interface ITCITenantOptions
 */
export interface ITCITenantComponentOptions<T> {
    /**
     * Gets the option label
     * @return string
     */
    getLabel(): string;

    /**
     * Gets the component selector type
     * @return @TCITenantSelectorType
     */
    getComponentSelectorType(): TCITenantSelectorType;

    /**
     * Gets the menu type
     * @return @TCI_MENU_TYPE
     */
    getOptionType(): T;

    /**
     * Get applicable tenant types
     * @return @TCITenantAppType[]
     */
    getTenantTypes(): TCITenantAppType[];

    /**
     * Gets the menu position
     * @return number
     */
    getPosition(): number;

    /**
     * Returns the route identifier if it exists
     */
    getRouteId(): string;

    /**
     * Returns the externalUrl if the component UI is an iframe
     */
    getExternalUrl(): string;
    /**
     * Set External URL based on tenant preload map
     */
    setExternalUrl(url: string): AbstractTCITenantComponentOptions<T>;
}

/**
 * class AbstractTCITenantOptions
 */
export abstract class AbstractTCITenantComponentOptions<T> implements ITCITenantComponentOptions<T> {

    constructor(protected optionLabel: string,
                protected componentSelectorType: TCITenantSelectorType,
                protected position: number,
                protected optionType: T,
                protected routeIdentifier: string,
                protected tenantTypes: TCITenantAppType[]
        , protected externalUrl: string) {
    }

    /**
     * compare with the given @TCITenantAppDetailsMenu
     * @param v
     * @return boolean
     */
    public isEqualTo(v: ITCITenantComponentOptions<T>): boolean {
        if (lodash.isUndefined(v) || lodash.isNull(v)) {
            return false;
        } else {
            return (this.optionLabel === v.getLabel()) &&
                (this.componentSelectorType.isEqualTo(v.getComponentSelectorType()
                        .toString()) &&
                    (v.getOptionType() === this.optionType));
        }
    }

    /**
     * Returns concatenated menu text with selector
     * @return string
     */
    public toString(): string {
        return `${this.optionLabel}-${this.componentSelectorType.toString()}`;
    }

    /**
     * Gets the menu string
     * @return string
     */
    getLabel(): string {
        return this.optionLabel;
    }

    /**
     * Gets the component selector type
     * @return @TCITenantSelectorType
     */
    getComponentSelectorType(): TCITenantSelectorType {
        return this.componentSelectorType;
    }

    /**
     * Gets the menu type
     * @return @T
     */
    getOptionType(): T {
        return this.optionType;
    }

    /**
     * Get applicable tenant types
     * @return @TCITenantAppType[]
     */
    getTenantTypes(): TCITenantAppType[] {
        return this.tenantTypes;
    }

    /**
     * Gets the menu position
     * @return number
     */
    getPosition(): number {
        return this.position;
    }

    /**
     * Returns the routeIdentfier
     */
    getRouteId(): string {
        return this.routeIdentifier;
    }

    /**
     * Returns the externalUrl if the component UI is an iframe
     */
    getExternalUrl(): string {
        return this.externalUrl;
    }

    /**
     * Set External URL based on tenant preload map
     */
    setExternalUrl(url: string): AbstractTCITenantComponentOptions<T> {
        this.externalUrl = url;
        return this;
    }
}


/**
 * Application property category enumeration
 * @type {{[K in string]: K}}
 */
export const TCIAppPropertyCategory = strEnum(["APP", "CONNECTION"]);
export type TCIAppPropertyCategory = keyof typeof TCIAppPropertyCategory;
/**
 * Application property type enumeration
 * @type {{[K in string]: K}}
 */
export const TCIAppPropertyDataType = strEnum(["none", "boolean", "number", "string", "password"]);
export type TCIAppPropertyDataType = keyof typeof TCIAppPropertyDataType;

/**
 * interface ITCIApplicationProperty
 */
export interface ITCIApplicationProperty {
    /**
     * property name
     */
    name: string;
    /**
     * property data type
     */
    dataType: TCIAppPropertyDataType;
    /**
     * property category
     */
    category: TCIAppPropertyCategory;
    /**
     * property default value
     */
    default_value: any;
}

export class TCIBaseApplicationProperty implements ITCIApplicationProperty {
    /**
     * property name
     */
    name: string;
    /**
     * property data type
     */
    dataType: TCIAppPropertyDataType;
    /**
     * property category
     */
    category: TCIAppPropertyCategory;
    /**
     * property default value
     */
    default_value: any;
    /**
     * categoryMetadata
     */
    categoryMetadata: string;

    /**
     * constructor
     * @param {string} name
     */
    constructor(name: string) {
        this.name = name;
    }

    /**
     * Returns the property name
     * @return {string}
     */
    getName(): string {
        return this.name;
    }

    /**
     * Returns ths Property Data Type
     * @return {AppPropertyDataType}
     */
    getDataType(): TCIAppPropertyDataType {
        return this.dataType;
    }

    /**
     * Returns the property category
     * @return {AppPropertyCategory}
     */
    getCategory(): TCIAppPropertyCategory {
        return this.category;
    }

    /**
     * Returns the default value
     * @return {any}
     */
    getDefaultValue(): any {
        return this.default_value;
    }

}


/**
 * interface ITCIApplicationProperties
 */
export interface ITCIApplicationProperties {
    [prop: string]: ITCIApplicationProperty;
}

/*************************************************************************************************/
/*                        TCI Application Request/Response                                       */

/*************************************************************************************************/
/**
 * interface @ITCITenantRequest
 */
export interface ITCITenantRequest {
    /**
     * TCI Application Type
     */
    tenantType?: TCITenantAppType;
}

/**
 * interface @ITCITenantResponse
 */
export interface ITCITenantResponse {
    /**
     * Application Response status
     */
    success: boolean;
    /**
     * Application Response message
     */
    msg?: string;
    /**
     * ApplicationCreation data to be returned
     */
    result?: any | ITCIFileMap;
}

/**
 * interface ITCIApplicationRequest
 */
export interface ITCIApplicationRequest extends ITCITenantRequest {
    /**
     * Application Id
     */
    appId?: string;
    /**
     * application object, present only on UI usage, and absent in backend
     */
    application?: ITCIApplication;
}

/**
 * interface ITCIApplicationResponse
 */
export interface ITCIApplicationResponse extends ITCITenantResponse {
    /**
     * Application Id
     */
    appId: string;
    /**
     * Application Name
     */
    name?: string;

}


/*************************************************************************************************/
/*                        TCI Application Get Request/Respon                                     */

/*************************************************************************************************/
/**
 * interface ITCIApplicationGetRequest
 */
export interface ITCIApplicationGetRequest extends ITCIApplicationRequest {
}

/**
 * interface ITCIApplicationGetResponse
 */
export interface ITCIApplicationGetResponse extends ITCIApplicationResponse {
}


export const enum TCI_APPLICATION_ERR_TYPE {
    ERR_TYPE_INFO = 0,
    ERR_TYPE_WARN = 1,
    ERR_TYPE_ERROR = 2,
    ERR_TYPE_FATAL = 3,
    ERR_TYPE_UNKNOWN = 4
}

/**
 * Info to be set as error input for tenant miniDetails component
 */
export interface ITCIApplicationErrorInfo {
    errorType: TCI_APPLICATION_ERR_TYPE;
    msg: string;
}

/**
 * Defines the characteristics of a status response category
 */
export interface ITCIAppStatusCategory {
    Color: string;
    IconUrl: string;
    ClassName: string;
}



